import { a as n } from "../as-num-DQjLjHSI.js";
import { BreakpointNames as a, BreakpointValues as s } from "../models/index.ts.js";
const i = (t, o) => {
  const r = t.length;
  for (let e = r - 1; e >= 0; e -= 1)
    if (n(t[e]) <= o) return e;
  return -1;
}, c = (t) => a[i(s, t)];
export {
  n as asNum,
  c as getBreakpoint,
  i as getClosestIndex
};
//# sourceMappingURL=index.ts.js.map
